import React, { useEffect, useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { ShoppingCartIcon } from "lucide-react";
import { CHECKOUT_URL } from "../data/content";
export function FloatingCta() {
  const [visible, setVisible] = useState(false);
  useEffect(() => {
    const onScroll = () => {
      const anchor = document.getElementById("hero-cta");
      if (!anchor) return;
      setVisible(anchor.getBoundingClientRect().bottom < 0);
    };
    onScroll();
    window.addEventListener("scroll", onScroll, {
      passive: true
    });
    window.addEventListener("resize", onScroll);
    return () => {
      window.removeEventListener("scroll", onScroll);
      window.removeEventListener("resize", onScroll);
    };
  }, []);
  return <AnimatePresence data-id="element-16" data-mp="bookx19fxr2w">
      {visible && <motion.div initial={{
      y: "120%"
    }} animate={{
      y: 0
    }} exit={{
      y: "120%"
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} className="fixed inset-x-0 bottom-0 z-40 px-3 pb-3 pt-2 md:inset-x-auto md:right-6 md:bottom-6 md:p-0" data-id="element-17" data-mp="196gawv4bwhoi">
          <a href={CHECKOUT_URL} className="animate-cta-shake flex w-full items-center justify-center gap-2.5 rounded-2xl bg-go px-5 py-4 text-[15px] font-extrabold uppercase tracking-wide text-white shadow-[0_10px_30px_-6px_rgba(17,103,47,0.6)] ring-2 ring-white hover:bg-go-dark md:px-7" data-id="element-18" data-mp="2f4ai7cwye0lb">
            <ShoppingCartIcon className="h-5 w-5 shrink-0" aria-hidden="true" data-id="element-19" data-mp="1rcwq982ps70v" />
            <span className="whitespace-nowrap" data-id="element-20" data-mp="1welzci6dmamb">Get it now — only $27</span>
          </a>
        </motion.div>}
    </AnimatePresence>;
}